/**
 * SessionIdentityRow — the shared "who is this conversation" fragment: agent
 * badge + display title + localised agent name, truncating. Composed by the
 * handover curation rows and the handover flagged-conversation rows (and any
 * future compact session list) so the identity block exists once.
 */
import { sessionSurfaceSlug, type SurfacedSession } from '@/lib/sessionRouting'
import { useTranslation } from 'react-i18next';
import { AgentBadge } from '@/components/AgentBadge';
import { useAgentCatalogue, useAgentLabel } from '@/hooks/useAgentCatalogue';
import { resolveAgentIdentity } from '@/lib/agentIdentity';
import { sessionDisplayTitle, type TitledSession } from '@/lib/sessionDisplay';

export function SessionIdentityRow({
  session,
}: {
  session: TitledSession & SurfacedSession;
}) {
  const { t } = useTranslation();
  const catalogue = useAgentCatalogue();
  const agentLabel = useAgentLabel();
  const identity = resolveAgentIdentity(sessionSurfaceSlug(session), catalogue);

  return (
    <>
      <AgentBadge identity={identity} size="sm" />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[13px] font-semibold text-neutral-900">
          {sessionDisplayTitle(session, t)}
        </span>
        <span className="block truncate text-[11.5px] text-neutral-400">
          {agentLabel(identity.slug, identity.name)}
        </span>
      </span>
    </>
  );
}
